import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import NpsAnswer from './NpsAnswer';


export default function NpsQuestion({ value,  questionId , onChange, sourceId}) {
	const { t } = useTranslation();

	const [score, setScore] = useState(value);

	const handleChange = (sourceId, questionId, v) => {	
		onChange?.(questionId, v);
		setScore(v);
	}

	return (
		<div className="form-group row">
			<div className="col-sm-12">
				<p className="npsLabel npsLabel-top">
					<span className="text-left">0={t("review.not")}</span><span className="text-right">10={t("review.abs")}</span>
				</p>
				<div className="npsPond">
					{[0, 1, 2, 3, 4, 5].map((x) => {
						return <NpsAnswer key={x} sourceId={sourceId} questionId={questionId} onChange={handleChange} value={x} checked={score} />
					})}
					<br className="npsHalf" />
					{[6, 7, 8, 9, 10].map((x) => {
						return <NpsAnswer key={x} sourceId={sourceId} questionId={questionId} onChange={handleChange} value={x} checked={score} />
					})}
				</div>
				<p className="npsLabel npsLabel-bottom">
					<span className="text-left">0={t("review.not")}</span>
					<span className="text-right">10={t("review.abs")}</span>
				</p>
			</div>
		</div>
	)
}
